import React, {useContext, useState} from "react";
import Paper from "@material-ui/core/Paper";
import MUIDataTable from "mui-datatables";
import SelectedSygnaturyZwrotyContext from "./SelectedSygnaturyZwrotyContext";
import ColumnsSortContext from "../ColumnSortContext";

const RealTimeSummaryTableZwroty = ({
  data,
  columns,
  keyName,
  selectedSygnaturyIds,
  setSelectedSygnaturyIds
}) => {
  const { sortColumns, setSortColumns } = useContext(ColumnsSortContext);
  const { selectedZ, setSelectedZ } = useContext(
    SelectedSygnaturyZwrotyContext
  );
  const [rowsSelected, setRowsSelected] = useState(selectedZ[keyName]);

  const handleChangeSelected = val => {
    if (val.length > 1 || !val.length) {
      return selectAllRows(val);
    }
    const index = val[0].dataIndex;
    const item = data[index];
    //selected rows in table
    if (rowsSelected.indexOf(index) !== -1) {
      setRowsSelected(rowsSelected.filter(it => it !== index));
      let newObj = selectedZ;
      newObj[keyName] = rowsSelected.filter(it => it !== index);
      setSelectedZ(newObj);
    } else {
      setRowsSelected([...rowsSelected, index]);
      let newObj = selectedZ;
      newObj[keyName] = [...rowsSelected, index];
      setSelectedZ(newObj);
    }
    // selected sygnatury ids from all tables
    if (selectedSygnaturyIds.indexOf(item.sygnaturaId) !== -1) {
      setSelectedSygnaturyIds(
        selectedSygnaturyIds.filter(it => it !== item.sygnaturaId)
      );
    } else {
      setSelectedSygnaturyIds([...selectedSygnaturyIds, item.sygnaturaId]);
    }
  };

  const selectAllRows = arr => {
    if (!arr.length) {
      const sygnaturyIdsToRemove = [];
      selectedZ[keyName].map(it => {
        sygnaturyIdsToRemove.push(data[it].sygnaturaId);

        return it;
      });

      const newArrSelectedSygnaturyIds = [];

      selectedSygnaturyIds.map(it => {
        const exist = sygnaturyIdsToRemove.indexOf(it) >= 0;

        if (!exist) {
          newArrSelectedSygnaturyIds.push(it);
        }

        return it;
      });

      let newObj = selectedZ;
      newObj[keyName] = [];
      setSelectedZ(newObj);
      setSelectedSygnaturyIds(newArrSelectedSygnaturyIds);
      setRowsSelected([]);
    } else {
      const sygnaturyIds = [];

      const idx = arr.map(it => {
        sygnaturyIds.push(data[it.index].sygnaturaId);
        return it.index;
      });

      let newObj = selectedZ;
      newObj[keyName] = idx;
      setSelectedZ(newObj);
      setSelectedSygnaturyIds([...selectedSygnaturyIds, ...sygnaturyIds]);
      setRowsSelected(idx);
    }
  };

  const changeColumnSortContext = (columnName, direction) => {
    let newSortColumns = sortColumns;
    let newDirection = false;

    if (direction === "ascending") {
      newDirection = "asc";
    } else {
      newDirection = "desc";
    }

    newSortColumns[keyName].zwroty.name = columnName;
    newSortColumns[keyName].zwroty.direction = newDirection;

    setSortColumns(newSortColumns);
  };

  const options = {
    download: false,
    print: false,
    rowsPerPage: 10,
    selectableRows: "multiple",
    disableToolbarSelect: true,
    rowsSelected: rowsSelected,
    selectableRowsHeader: true,
    onRowsSelect: handleChangeSelected,
    onColumnSortChange: (changedColumn, direction) => {
      changeColumnSortContext(changedColumn, direction);
    }
  };

  return (
    <Paper>
      <MUIDataTable data={data} columns={columns} options={options} />
    </Paper>
  );
};

export default RealTimeSummaryTableZwroty;
